// removed by extract-text-webpack-plugin
module.exports = {"order-history":"order-history"};


//////////////////
// WEBPACK FOOTER
// ./components/users/sub-view/order-history-content/_OrderHistoryContent.scss
// module id = ./components/users/sub-view/order-history-content/_OrderHistoryContent.scss
// module chunks = 0